import SVGComponent from "../SVGComponent";
import ICONS from "../../../assets/Icons";

/**
 *
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 * @param {object} props
 * @param {string} [props.icon]
 * @param {string} [props.iconColor]
 * @param {string} [props.title] Title to show. if this is not given the texts[0] is shown.
 * @param {string[] | string} props.texts Text to show.
 * - If this is a string then that string will be shown.
 * - If this is a list of strings then they will be shown as a bulleted list
 * @param {OnClickEventHandler} [props.onClick] If this is given, the card can be clickable.
 * @param {string[] | string} [props.highlightedText]
 * Text or list of texts to highlight within the provided `texts`.
 * Each highlighted text is rendered as an underlined, clickable button.
 * @param {(
 *   event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
 *   index: number
 * ) => void} [props.onHighlightedTextClick]
 * Callback triggered when a highlighted text is clicked.
 * The index identifies which highlighted text was clicked.
 */

export default function CommonAlertCard({
  icon,
  iconColor,
  texts,
  onClick,
  title,
  highlightedText,
  onHighlightedTextClick,
}) {
  const processedTexts = Array.isArray(texts) ? texts : [texts];

  const renderText = (text) => {
    if (!text) return null;

    const highlightedTexts = Array.isArray(highlightedText)
      ? highlightedText
      : [highlightedText];
    let currentText = text;
    const parts = [];

    highlightedTexts.forEach((item, index) => {
      if (!item) return;

      const itemIndex = currentText.indexOf(item);
      if (itemIndex === -1) return;
      parts.push(currentText.slice(0, itemIndex));
      parts.push(
        <button
          key={`highlighted-${index}`}
          type="button"
          className="font-semibold underline cursor-pointer"
          onClick={(event) => {
            event.stopPropagation();
            onHighlightedTextClick?.(event, index);
          }}
        >
          {item}
        </button>,
      );
      currentText = currentText.slice(itemIndex + item.length);
    });
    parts.push(currentText);
    return parts;
  };

  const getTextWithTitle = () => {
    if (true) {
      return (
        <>
          <div
            className={`flex flex-col ${processedTexts.length > 1 ? "gap-gap-sm" : "gap-gap-xs"}`}
          >
            {title && <div className="text-font-sm font-semibold">{title}</div>}
            <div className="text-font-xs">
              {processedTexts.length > 1 ? (
                <ol className="list-disc list-outside text-font-xs ml-margin-md">
                  {processedTexts.map((t, i) => (
                    <li
                      key={i}
                      className={
                        i !== processedTexts.length - 1 && "mb-margin-sm"
                      }
                    >
                      {renderText(t)}
                    </li>
                  ))}
                </ol>
              ) : (
                renderText(processedTexts[0])
              )}
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="text-font-xs">{processedTexts[0]}</div>
        </>
      );
    }
  };
  return (
    <>
      <div
        onClick={onClick || undefined}
        className={`w-full bg-emphasis rounded-border-radius-md p-padding-md relative z-z-index-content text-text-primary ${onClick ? "global-hover-white cursor-pointer" : ""} ${processedTexts.length > 1 ? "pb-padding-md" : "pb-padding-md"}`}
      >
        <div className="flex flex-row justify-between items-start gap-gap-sm">
          <div className="flex flex-row gap-gap-sm items-center">
            {icon !== "" && (
              <span>
                {iconColor ? (
                  <>
                    <div className="flex-shrink-0 w-icon-md h-icon-md">
                      <SVGComponent
                        url={icon || ICONS?.ERROR_WITH_WHITE_CIRCLE}
                        alt=""
                        color={iconColor}
                        height={"var(--icon-md)"}
                        width="var(--icon-md)"
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="w-icon-md h-icon-md flex-shrink-0">
                      <img
                        src={icon || ICONS?.ERROR_WITH_WHITE_CIRCLE}
                        alt=""
                      />
                    </div>
                  </>
                )}
              </span>
            )}
            {getTextWithTitle()}
          </div>
          {onClick && (
            <div className="pt-padding-xs flex-shrink-0">
              <SVGComponent
                url={ICONS.ARROW_RIGHT_WHITE}
                height={"var(--icon-sm)"}
                width="var(--icon-sm)"
                color="var(--text-primary)"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
